import type { Special } from "../types";

export const specials: Special[] = [
  {
    id: 1,
    title: "年度科幻神作盘点",
    subtitle: "2026 不可错过的星海想象",
    cover: "https://readdy.ai/api/search-image?query=Epic%20sci-fi%20collection%20banner%2C%20a%20sweeping%20deep%20space%20galaxy%20with%20glowing%20nebula%20and%20distant%20planets%2C%20teal%20and%20gold%20cosmic%20light%2C%20cinematic%20wide%20banner%20with%20clean%20negative%20space%20on%20one%20side&width=1200&height=675&seq=special-cover-01&orientation=landscape",
    description:
      "从深空探索到机械纪元，从海底深渊到时空信笺，为你精选本年度最具想象力与制作水准的科幻佳作，感受人类对未知最浪漫的追问。",
    reason: "由编辑部结合口碑、票房与专业影评综合评选，兼具视听震撼与思想深度。",
    movieIds: [1, 4, 9, 8, 12],
  },
  {
    id: 2,
    title: "悬疑烧脑高分片单",
    subtitle: "每一个细节都是伏笔",
    cover: "https://readdy.ai/api/search-image?query=Moody%20suspense%20mystery%20collection%20banner%2C%20a%20dark%20rainy%20city%20with%20dim%20street%20lamps%20and%20long%20shadows%2C%20cold%20teal%20and%20grey%20tones%20with%20a%20single%20warm%20light%2C%20cinematic%20wide%20banner&width=1200&height=675&seq=special-cover-02&orientation=landscape",
    description:
      "凶手是谁？真相在哪？这一份片单汇集了近年评分最高的悬疑犯罪电影，层层反转、环环相扣，请务必看到最后一分钟。",
    reason: "剧情缜密、反转高级，适合喜欢动脑与沉浸式推理的影迷。",
    movieIds: [2, 6, 13, 18, 12],
  },
  {
    id: 3,
    title: "治愈系爱情电影精选",
    subtitle: "愿你被这个世界温柔以待",
    cover: "https://readdy.ai/api/search-image?query=Soft%20romantic%20film%20collection%20banner%2C%20a%20sunlit%20spring%20lane%20with%20blooming%20flowers%20and%20gentle%20bokeh%2C%20pastel%20pink%20and%20cream%20tones%2C%20dreamy%20cinematic%20wide%20banner%20with%20warm%20haze&width=1200&height=675&seq=special-cover-03&orientation=landscape",
    description:
      "不狗血、不撕心，只有恰到好处的心动与熨帖。下班之后的夜晚，配一杯热饮，让这些温柔的故事陪你慢慢睡去。",
    reason: "节奏舒缓、情感真挚，是疲惫生活里最好的一剂安慰。",
    movieIds: [5, 8, 3, 15, 18],
  },
  {
    id: 4,
    title: "华语动作片黄金十年",
    subtitle: "拳拳到肉，快意江湖",
    cover: "https://readdy.ai/api/search-image?query=Dynamic%20Chinese%20action%20collection%20banner%2C%20a%20misty%20bamboo%20forest%20with%20dramatic%20sword%20motion%20and%20flying%20sparks%2C%20jade%20green%20and%20ink%20black%20tones%20with%20amber%20highlights%2C%20cinematic%20wide%20banner&width=1200&height=675&seq=special-cover-04&orientation=landscape",
    description:
      "从都市追凶到雪山冒险，从武侠江湖到极速狂飙，盘点近十年让观众热血沸腾的华语动作佳作，重温那种心跳加速的爽快。",
    reason: "动作设计扎实、场面震撼，兼顾娱乐性与艺术追求。",
    movieIds: [2, 7, 14, 16, 1],
  },
  {
    id: 5,
    title: "适合深夜独自观看的佳作",
    subtitle: "一个人的电影时光",
    cover: "https://readdy.ai/api/search-image?query=Quiet%20night%20cinema%20collection%20banner%2C%20a%20cozy%20dim%20room%20with%20a%20warm%20floor%20lamp%20and%20a%20glowing%20screen%2C%20deep%20blue%20and%20amber%20intimate%20tones%2C%20cinematic%20wide%20banner%20with%20soft%20grain&width=1200&height=675&seq=special-cover-05&orientation=landscape",
    description:
      "有些电影，适合一个人、在深夜、关掉弹幕慢慢看完。它们安静、克制，却总能在某个瞬间击中你。",
    reason: "情绪浓度高、后劲十足，配合深夜的安静刚刚好。",
    movieIds: [3, 10, 15, 9, 18],
  },
  {
    id: 6,
    title: "动画电影合家欢推荐",
    subtitle: "大人小孩都能笑着看完",
    cover: "https://readdy.ai/api/search-image?query=Colorful%20animated%20family%20collection%20banner%2C%20floating%20dreamy%20islands%20above%20a%20turquoise%20sea%20with%20playful%20creatures%2C%20bright%20teal%20gold%20and%20coral%20palette%2C%20cinematic%20wide%20banner%2C%20whimsical%20and%20warm&width=1200&height=675&seq=special-cover-06&orientation=landscape",
    description:
      "周末的家庭时光，需要一部全家都能投入的电影。这里有天马行空的想象、明亮的色彩，以及藏在欢笑里的成长道理。",
    reason: "画面精美、寓教于乐，是亲子观影的安心之选。",
    movieIds: [17, 7, 3, 12, 5],
  },
];